import React from "react";
import * as S from "./Breadcrumb.styles";

export interface BreadcrumbCollapserProps {
  title: string;
}

export const BreadcrumbCollapser: React.FC<BreadcrumbCollapserProps> = ({
  title
}) => (
  <S.Wrapper>
    <S.CollapserContent title={title}>...</S.CollapserContent>
    <S.Chevron />
  </S.Wrapper>
);

BreadcrumbCollapser.displayName = "BreadcrumbCollapser";
